import React from 'react'

import Dashboard from "./components/Dashboard"
import {ThemeProvider} from '@material-ui/styles'
import {createAppTheme} from './styles/Theme'


function App() {
  const [darkMode, setDarkMode] = React.useState(() => {
    const savedTheme = window.localStorage.getItem("color-theme");
    if (savedTheme) return savedTheme === "dark";
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  const theme = React.useMemo(() => createAppTheme(darkMode), [darkMode]);

  const toggleTheme = () => {
    setDarkMode(currentMode => {
      const nextMode = !currentMode;
      window.localStorage.setItem("color-theme", nextMode ? "dark" : "light");
      return nextMode;
    });
  };

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <Dashboard darkMode={darkMode} onToggleTheme={toggleTheme} />
      </ThemeProvider>
    </div>
  );
}

export default App;
